import React, { useState, useEffect } from "react";
import {
  Select,
  List,
  Card,
  Typography,
  Space,
  Divider,
  Tag,
  Input,
  Button,
  Modal,
  Table,
  Badge,
  Row,
  Col,
  Statistic,
  Alert,
  Empty,
  Spin,
  notification,
  message,
  DatePicker,
  Form,
  Popconfirm,
  InputNumber,
} from "antd";
import {
  ShoppingCartOutlined,
  UserOutlined,
  CalendarOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  EyeOutlined,
  SendOutlined,
  PlusOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { getAsignacionesSostenibilidad } from "../../services/financiero/plandecompras/planesdecomprasostenibilidad";
import ModalParticipantes from "./ModalParticipantes";
import { useSelector } from "react-redux";
import ActaEntregaPDFAlmacenar from "./FormatoActaEntregaPdf";
import { pdf } from "@react-pdf/renderer";
import isEqual from "lodash/isEqual"; // para comparar arrays/objetos profundamente
import {
  createSalidaBodegaService,
  deleteProductoDeSalida,
  updateSalidaBodegaService,
  uploadFormatoEntrega,
} from "../../services/entregas/servicesEntregas";
import dayjs, { Dayjs } from "dayjs";

import config from "../../config";
const baseUrl = config.baseUrl;

const { Option } = Select;
const { Title, Text } = Typography;
const { Search } = Input;

const SalidaBodega_v2 = ({
  cargarDatos,
  isEditing = false,
  recordUpdate = [],
  closeModal,
}) => {
  const [proyectos, setProyectos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);
  const [listaParticipantes, setListaParticipantes] = useState([]);
  const [listaParticipantesSeleccionados, setListaParticipantesSelecionados] =
    useState([]);
  const [productosSeleccionados, setProductosSeleccionados] = useState([]);
  const [productosUnificados, setProductosUnificados] = useState([]);

  const [busquedaProducto, setBusquedaProducto] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalEntrega, setModalEntrega] = useState(false);
  const [modalParticipantes, setModalParticipantes] = useState(false);
  const usernameFromState = useSelector((state) => state.auth.user);
  const [modalEntregaFecha, setModalEntregaFecha] = useState(false);
  const [form] = Form.useForm(); // 👈 aquí declaras la instancia del formulario
  const [hayCambios, setHayCambios] = useState(false);

  const listaOriginal =
    recordUpdate?.jsonDetalleSalida?.entrega?.lista_participantes || [];

  useEffect(() => {
    // Compara original vs editable
    if (!isEqual(listaParticipantesSeleccionados, listaOriginal)) {
      setHayCambios(true); // Habilita botón actualizar
    } else {
      setHayCambios(false); // Deshabilita botón actualizar
    }
  }, [listaParticipantesSeleccionados, listaOriginal]);

  const [
    productosSeleccionadosEntregados,
    setProductosSeleccionadosEntregados,
  ] = useState([]);

  const fetchPlanes = async () => {
    try {
      setLoading(true);

      const r = isEditing
        ? await getAsignacionesSostenibilidad(
            recordUpdate.jsonDetalleSalida.proyecto.proyecto_oid
          )
        : await getAsignacionesSostenibilidad();

      if (r?.status === 200) {
        const dataProyecto = r.data[0];
        setProyectos(r.data);
        setListaParticipantes(dataProyecto.participantes);
        if (isEditing) {
          // ✅ Solo al primer render inicializas productosSeleccionadosEntregados
          if (productosSeleccionadosEntregados.length === 0) {
            setProductosSeleccionadosEntregados(
              normalizarProductos(
                recordUpdate.jsonDetalleSalida.entrega.items,
                recordUpdate.oid
              )
            );
          }
          // ✅ Convertir a dayjs porque DatePicker trabaja con objetos de fecha
          form.setFieldsValue({
            fechaEntrega: dayjs(
              recordUpdate.jsonDetalleSalida.entrega.fechaCompleta
            ),
            valorTotalEntrega:
              recordUpdate.jsonDetalleSalida.entrega.valorTotalEntrega,
          });
          setListaParticipantes(dataProyecto.participantes);
          setProyectoSeleccionado(dataProyecto);
        } else {
          setProyectoSeleccionado(undefined);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //Ingeso en modo de edición
    if (isEditing) {
      setListaParticipantesSelecionados(
        recordUpdate.jsonDetalleSalida.entrega.lista_participantes
      );
      //Ingreso en modo de creación
    }
    fetchPlanes();
  }, []);

  useEffect(() => {
    // 🔹 Normalizar seleccionados
    const normalizarSeleccionados = (items) =>
      items.map((item) => ({
        po_item: {
          po_producto_oid: item.po_item.po_producto_oid,
          descripcion_po: item.po_item.descripcion_po,
          unidad_po: item.po_item.unidad_po,
          cantidad_po: item.po_item.cantidad_po,
          valor_unitario: item.po_item.valor_unitario,
          proveedor: item.po_item.po?.proveedor,
          numero_orden: item.po_item.po?.numero_orden,
        },
        cantidad_total: item.cantidad_total,
        valor_total: item.valor_total,
        asignaciones: item.po_item.asignaciones,
        origen: "nuevo",
      }));

    // 🔹 Normalizar entregados
    const normalizarEntregados = (items) =>
      items.map((item) => ({
        po_item: {
          po_producto_oid: item.po_item.po_producto_oid,
          descripcion_po: item.po_item.descripcion_po,
          unidad_po: item.po_item.unidad_po,
          cantidad_po: item.po_item.cantidad_po,
          valor_unitario: item.po_item.valor_unitario,
          proveedor: item.producto?.orden_compra?.proveedor,
          numero_orden: item.producto?.orden_compra?.numero_orden,
        },
        cantidad_total:
          item.po_item.cantidad_total ?? item.producto?.cantidad_total ?? 0,
        valor_total:
          (item.producto?.cantidad_total ?? 0) *
          (item.po_item.valor_unitario ?? 0),
        asignaciones: item.asignaciones ?? item.producto?.asignaciones ?? [],
        origen: "entregado",
      }));

    // 🔹 Unificar ambos
    const productosUnificados = [
      ...normalizarEntregados(productosSeleccionadosEntregados),
      ...normalizarSeleccionados(productosSeleccionados),
    ];

    setProductosUnificados(productosUnificados);

    // 👉 aquí puedes setearlos en un estado global o local
    // setProductosUnificados(productosUnificados);
  }, [productosSeleccionados, productosSeleccionadosEntregados]);

  // Generar lista única de código_interno - implementador
  const getProyectosUnicos = () => {
    const proyectosUnicos = [];
    const seen = new Set();

    proyectos.forEach((proyecto) => {
      const key = `${proyecto.codigo_interno} - ${proyecto.implementador}`;
      if (!seen.has(key)) {
        seen.add(key);
        proyectosUnicos.push({
          key: proyecto.proyecto_oid,
          value: key,
          proyecto: proyecto,
        });
      }
    });

    return proyectosUnicos;
  };

  const handleProyectoChange = (value, option) => {
    setProyectoSeleccionado(option.proyecto);
    setListaParticipantes(option.proyecto.participantes || []);
    setProductosSeleccionados([]);
    setBusquedaProducto("");
  };

  const handleProductoSelect = (productoUnico) => {
    const poProductoOid = productoUnico?.po_item?.po_producto_oid;

    const isSelected = productosSeleccionados.some(
      (p) => p.po_item.po_producto_oid === poProductoOid
    );

    if (isSelected) {
      const updated = productosSeleccionados.filter(
        (p) => p.po_item.po_producto_oid !== poProductoOid
      );
      setProductosSeleccionados(updated);
    } else {
      const updated = [...productosSeleccionados, productoUnico];
      setProductosSeleccionados(updated);
    }
  };

  const removeProductoSeleccionado = (descripcionProducto) => {
    setProductosSeleccionados(
      productosSeleccionados.filter(
        (p) => p.po_item.descripcion_po !== descripcionProducto
      )
    );
  };

  const removeProductoSeleccionadoEntregado = async (item) => {
    const po_producto_oid = item?.po_item?.po_producto_oid;
    const asignaciones = item?.asignaciones?.map((a) => a.asignacion_oid) || [];
    const id_salida = item?.id_salida;

    try {
      const response = await deleteProductoDeSalida({
        po_producto_oid,
        asignaciones,
        id_salida,
      });

      if (response.success) {
        message.success("Producto eliminado correctamente ✅");

        // ✅ Quitar producto eliminado del estado local
        setProductosSeleccionadosEntregados((prev) =>
          prev.filter(
            (p) =>
              !(
                p.po_item.po_producto_oid === po_producto_oid &&
                p.id_salida === id_salida
              )
          )
        );

        // 🔄 puedes refrescar info adicional si es necesario
        fetchPlanes();
        cargarDatos();
      } else {
        message.warning(
          response.message || "No se pudo eliminar el producto ⚠️"
        );
      }
    } catch (error) {
      console.error("❌ Error al eliminar el producto:", error);
      message.error("Error al eliminar el producto ❌");
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
    }).format(value);
  };

  // Obtener productos únicos por descripción
  const getProductosUnicos = () => {
    if (!proyectoSeleccionado) return [];

    const productosMap = new Map();

    proyectoSeleccionado.po_items.forEach((item) => {
      // 🔹 Sumar asignaciones desde po_item.asignaciones
      const cantidadAsignadaTotal =
        item.po_item.asignaciones?.reduce(
          (sum, a) => sum + a.cantidad_asignada,
          0
        ) || 0;

      const key = item.po_item.descripcion_po;

      if (!productosMap.has(key)) {
        productosMap.set(key, {
          ...item,
          po_items_relacionados: [item],
          cantidad_po: item.po_item.cantidad_po, // original PO
          cantidad_total: cantidadAsignadaTotal, // asignaciones
          valor_total: cantidadAsignadaTotal * item.po_item.valor_unitario,
        });
      } else {
        const existing = productosMap.get(key);
        existing.po_items_relacionados.push(item);
        existing.cantidad_total += cantidadAsignadaTotal;
        existing.valor_total +=
          cantidadAsignadaTotal * item.po_item.valor_unitario;
      }
    });

    return Array.from(productosMap.values());
  };

  // Filtrar productos únicos por búsqueda
  const getProductosFiltrados = () => {
    const productosUnicos = getProductosUnicos();

    return productosUnicos.filter(
      (item) =>
        item.po_item.descripcion_po
          .toLowerCase()
          .includes(busquedaProducto.toLowerCase()) ||
        item.po_items_relacionados.some(
          (related) =>
            related.po_item.po.numero_orden
              .toLowerCase()
              .includes(busquedaProducto.toLowerCase()) ||
            related.po_item.po.proveedor
              .toLowerCase()
              .includes(busquedaProducto.toLowerCase())
        )
    );
  };

  // Columnas para la tabla del modal de entrega
  const columnasEntrega = [
    {
      title: "Numero de orden",
      key: ["po_item", "numero_orden"],
      align: "right",
      width: 100,

      render: (_, record) => (
        <Tag color="blue" style={{ fontSize: "14px", padding: "4px 8px" }}>
          {record.po_item.numero_orden}
        </Tag>
      ),
    },
    {
      title: "Producto",
      dataIndex: ["po_item", "descripcion_po"],
      key: "producto",
      width: 250,
      render: (text) => <Text strong>{text}</Text>,
    },

    {
      title: "Cantidad Total",
      key: "cantidad_total",
      align: "center",
      width: 150,
      render: (_, record) => (
        <Tag color="blue" style={{ fontSize: "14px", padding: "4px 8px" }}>
          {record.cantidad_total} unidades
        </Tag>
      ),
    },

    {
      title: "Valor unitario",
      key: ["po_item", "valor_unitario"],
      align: "center",
      width: 150,
      render: (_, record) => (
        <Text strong style={{ color: "#1890ff", fontSize: "14px" }}>
          {formatCurrency(record.po_item.valor_unitario)}
        </Text>
      ),
    },

    {
      title: "Valor total",
      key: "valor_total",
      align: "center",
      width: 150,
      render: (_, record) => (
        <Text strong style={{ color: "#1890ff", fontSize: "14px" }}>
          {formatCurrency(record.valor_total)}
        </Text>
      ),
    },
  ];

  const proyectosUnicos = getProyectosUnicos();
  const productosFiltrados = getProductosFiltrados();
  const totalSeleccionados = productosUnificados.reduce(
    (total, item) => total + item.valor_total,
    0
  );

  // Función para procesar y armar el JSON de entrega
  // Función para procesar y armar el JSON de entrega
  const procesarEntrega = (
    productosSeleccionados,
    proyectoSeleccionado,
    values
  ) => {
    // Acumular todos los asignacion_oid
    const asignacionesOids = [];
    // Acumular todos los seriales
    const serialesGlobales = [];

    // Procesar productos para extraer los items y asignaciones
    const itemsEntrega = productosSeleccionados.map((producto) => {
      const { po_item, cantidad_total } = producto;

      // Extraer asignacion_oid y seriales de cada producto
      if (po_item.asignaciones && po_item.asignaciones.length > 0) {
        po_item.asignaciones.forEach((asignacion) => {
          asignacionesOids.push(asignacion.asignacion_oid);

          if (asignacion.seriales && asignacion.seriales.length > 0) {
            serialesGlobales.push(...asignacion.seriales);
          }
        });
      }

      return {
        po_producto_oid: po_item.po_producto_oid,
        descripcion_po: po_item.descripcion_po,
        unidad_po: po_item.unidad_po,
        cantidad_po: po_item.cantidad_po,
        valor_unitario: po_item.valor_unitario,
        cantidad_total: cantidad_total,
        iva: po_item.iva,
        orden_compra: {
          numero_orden: po_item.po.numero_orden,
          fecha_po: po_item.po.fecha_po,
          proveedor: po_item.po.proveedor,
          proveedor_id: po_item.po.proveedor_id,
        },
        lote: {
          lote_oid: po_item.lote.lote_oid,
          cantidad_entrada: po_item.lote.cantidad_entrada,
          fecha_creacion: po_item.lote.fecha_creacion,
        },
        asignaciones: po_item.asignaciones.map((asignacion) => ({
          asignacion_oid: asignacion.asignacion_oid,
          plan_oid: asignacion.plan_oid,
          cantidad_asignada: asignacion.cantidad_asignada,
          fecha_asignacion: asignacion.fecha_asignacion,
          seriales: asignacion.seriales || [],
          producto_plan: {
            oid: asignacion.producto_plan.oid,
            codigo: asignacion.producto_plan.codigo,
            nombre: asignacion.producto_plan.nombre,
            descripcion: asignacion.producto_plan.descripcion,
            cantidad_entrante_plan_compra:
              asignacion.producto_plan.cantidad_entrante_plan_compra,
            categoria: asignacion.producto_plan.categoria,
            unidad_plan: asignacion.producto_plan.unidad_plan,
            section: asignacion.producto_plan.section,
          },
        })),
      };
    });

    // Generar balance de productos (cantidad entregada vs asignada)
    const balanceItems = itemsEntrega.map((item, index) => {
      const cantidadAsignadaTotal = item.asignaciones.reduce(
        (sum, a) => sum + a.cantidad_asignada,
        0
      );

      const serialesItem = item.asignaciones.flatMap(
        (asignacion) => asignacion.seriales || []
      );

      return {
        item: index + 1,
        po_producto_oid: item.po_producto_oid,
        descripcion: item.descripcion_po,
        seriales: serialesItem.length > 0 ? serialesItem : [""],
        valor_unitario: item.valor_unitario,
        unidad: item.unidad_po,
        cantidad: cantidadAsignadaTotal,
      };
    });

    // Totales
    const cantidad_total_items = balanceItems.reduce(
      (sum, b) => sum + b.cantidad,
      0
    );

    const valor_total = balanceItems.reduce(
      (sum, b) => sum + b.cantidad * b.valor_unitario,
      0
    );

    //Obtener datos de la fecha asignada de la entrega
    const fecha = values.fechaEntrega;
    const dia = fecha.date();
    const mes = fecha.month() + 1;
    const vigencia = fecha.year();
    const fechaCompleta = `${vigencia}-${mes}-${dia}`;

    //Obtener el valor total de la entrega manual
    const valorTotalEntrega = values.valorTotalEntrega;

    //Obtener participantes firmantes
    const firmantes = listaParticipantes.filter(
      (p) => p.firmante === "SI"
    ).length;

    const noFirmantes = listaParticipantes.filter(
      (p) => p.firmante === "NO"
    ).length;

    // Armar el JSON final
    const jsonEntrega = {
      proyecto: {
        proyecto_oid: proyectoSeleccionado.proyecto_oid,
        nombre_proyecto: proyectoSeleccionado.nombre_proyecto,
        direccion_proyecto_productivo:
          proyectoSeleccionado?.ubicacion &&
          proyectoSeleccionado.ubicacion.trim() !== ""
            ? proyectoSeleccionado.ubicacion
            : "",
        linea_productiva: proyectoSeleccionado.linea_productiva,
        sector: proyectoSeleccionado.sector,
        codigo_interno: proyectoSeleccionado.codigo_interno,
        nombre_profesional_gse: proyectoSeleccionado.nombre_profesional_gse,
        oid_grupoTerritorial: proyectoSeleccionado.oid_grupoTerritorial,
        oid_proyecto_municipio: proyectoSeleccionado.oid_proyecto_municipio,
        implementador: proyectoSeleccionado.implementador,
        sigla: proyectoSeleccionado.sigla,
        oid_proceso: proyectoSeleccionado.oid_proceso,
        id_organizacionxProyecto: proyectoSeleccionado.id_organizacionxProyecto,
        memorando: proyectoSeleccionado.memorando,
        fechaAsignacion: proyectoSeleccionado.fechaAsignacion,
        fechaTerminacion: proyectoSeleccionado.fechaTerminacion,
        codPre: proyectoSeleccionado.codPre,
        territorio: proyectoSeleccionado.territorio,
        personas_reincorporacion: firmantes,
        personas_comunidad: noFirmantes,
      },

      entrega: {
        fecha_sistema: new Date().toISOString(),
        fechaEntrega: {
          dia,
          mes,
          vigencia,
          fechaCompleta,
        },
        valorTotalEntrega: valorTotalEntrega,
        items: itemsEntrega,
        cantidad_total_items,
        valor_total,
        balance_items: balanceItems,
        lista_participantes: listaParticipantesSeleccionados,
        seriales_globales: [...new Set(serialesGlobales)],
      },
      asignaciones_oids: [...new Set(asignacionesOids)],
    };

    return jsonEntrega;
  };

  const generatePdfBlob = async (data) => {
    try {
      let doc = <ActaEntregaPDFAlmacenar data={data} />;
      const asPdf = pdf();
      await asPdf.updateContainer(doc); // ⚠️ esta es asíncrona
      const blob = await asPdf.toBlob();
      return blob;
    } catch (error) {
      console.error("❌ Error al generar el PDF:", error);
      return null;
    }
  };

  const handleConfirmarEntrega = async (values) => {
    const jsonEntrega = procesarEntrega(
      productosSeleccionados,
      proyectoSeleccionado,
      values
    );

    if (isEditing) {
      handleActualizarEntrega(jsonEntrega);
    } else {
      const body = {
        valor_total: jsonEntrega.entrega.valor_total,
        oidResponsable: usernameFromState?.username,
        tipo_salida: "EntregaSostenibilidad",
        jsonDetalleSalida: jsonEntrega,
        idProyecto: jsonEntrega.proyecto.proyecto_oid,
        asignaciones_oids: jsonEntrega.asignaciones_oids,
      };

      try {
        // Paso 1: Insertar salida en backend
        const response = await createSalidaBodegaService(body);

        if (!response || response.status !== 201) {
          notification.error({
            message: "Error en la entrega",
            description: response?.message || "No se pudo registrar la salida.",
            placement: "topRight",
          });
          return;
        }

        notification.success({
          message: "Entrega registrada",
          description: "La acta de entrega se registró exitosamente.",
          placement: "topRight",
        });

        const salidaId = response.salidaId;
        const codActa = response.codActa;

        /*
        // Paso 2: Generar y subir PDF (opcional, no bloquea el flujo)
        try {
          const initialFormData = {
            implementador: jsonEntrega.proyecto.implementador,
            codigo_pre: jsonEntrega.proyecto.codPre,
            direccion_proyecto_productivo:
              jsonEntrega.proyecto.direccion_proyecto_productivo,
            proyecto_productivo: jsonEntrega.proyecto.nombre_proyecto,
            linea_productiva: jsonEntrega.proyecto.linea_productiva,
            fecha_entrega_parcial: jsonEntrega.entrega.fecha_entrega,
            fecha_entrega_final: "",
            grupo_territorial: jsonEntrega.proyecto.territorio.grupo.nombre,
            departamento: jsonEntrega.proyecto.territorio.departamento.nombre,
            municipio: jsonEntrega.proyecto.territorio.municipio.nombre,
            numero_personas_reincorporacion:
              jsonEntrega.entrega.lista_participantes.length,
            numero_personas_comunidad: "",
            lista_participantes: jsonEntrega.entrega.lista_participantes,
            lista_insumos: jsonEntrega.entrega.balance_items,
            sitio_entrega: "",
            codigo_interno: codActa,
            valor_total: jsonEntrega.entrega.valor_total,
            seriales: jsonEntrega.entrega.seriales_globales,
            dia: jsonEntrega.entrega.fechaEntrega.dia,
            mes: jsonEntrega.entrega.fechaEntrega.mes,
            vigencia: jsonEntrega.entrega.fechaEntrega.vigencia,
            personas_reincorporacion:
              jsonEntrega.proyecto.personas_reincorporacion,
            personas_comunidad: jsonEntrega.proyecto.personas_comunidad,
          };

          const pdfBlob = await generatePdfBlob(initialFormData);

          const uploadResp = await uploadFormatoEntrega(salidaId, "0", pdfBlob);

          if (uploadResp.success) {
            // 👉 Generar URL con timestamp para evitar caché
            const urlConTimestamp = `${baseUrl}/${
              uploadResp.archivo.ruta
            }?t=${new Date().getTime()}`;

            // Abrir el PDF en una nueva ventana
            window.open(urlConTimestamp, "_blank");
            message.success("Documento cargado exitosamente");
          } else {
            message.warning(
              uploadResp.message ||
                "Entrega guardada, pero hubo error al cargar documento"
            );
          }
        } catch (pdfError) {
          message.warning(
            "Entrega guardada, pero no se pudo generar el documento"
          );
        }
        */
      } catch (error) {
        notification.error({
          message: "Error en el servidor",
          description: error.message || "Error inesperado al registrar salida.",
          placement: "topRight",
        });
      } finally {
        // Paso 3: Limpieza y recarga SIEMPRE se ejecuta
        form.resetFields(); // limpiar después de confirmar
        setModalEntregaFecha(false);
        setModalEntrega(false);
        setProductosSeleccionados([]);
        setModalVisible(false);
        setProyectoSeleccionado(null);
        setBusquedaProducto("");
        setListaParticipantes([]);
        setListaParticipantesSelecionados([]);
        fetchPlanes();
        cargarDatos();
      }
    }
  };

  const handleActualizarEntrega = async (jsonEntrega) => {
    // 1) Extraer los productos entregados (del hijo .producto)
    const entregados = productosSeleccionadosEntregados.map(
      (item) => item.producto
    );

    // 2) Unificamos dentro de jsonEntrega.entrega.items
    const mergedItems = [...(jsonEntrega.entrega.items || []), ...entregados];

    // --- Helpers para normalizar/extraer ---
    const extractAsignaciones = (item) => {
      if (!item) return [];
      if (Array.isArray(item.asignaciones) && item.asignaciones.length)
        return item.asignaciones;
      if (item.producto && Array.isArray(item.producto.asignaciones))
        return item.producto.asignaciones;
      return [];
    };

    const getValorUnitario = (item) =>
      Number(item.valor_unitario ?? item.producto?.valor_unitario ?? 0);

    const getUnidad = (item) =>
      item.unidad_po ?? item.producto?.unidad_po ?? "";

    const getPoProductoOid = (item) =>
      item.po_producto_oid ?? item.producto?.po_producto_oid;

    const getDescripcion = (item) =>
      item.descripcion_po ?? item.producto?.descripcion_po ?? "";

    const getCantidadFallback = (item) =>
      Number(
        item.cantidad_total ??
          item.cantidad_po ??
          item.producto?.cantidad_total ??
          item.producto?.cantidad_po ??
          0
      );

    // 3) Recalcular asignaciones_oids, seriales_globales y balance_items
    const asignacionesSet = new Set();
    const serialesSet = new Set();

    const balanceItems = mergedItems.map((item, index) => {
      const asignaciones = extractAsignaciones(item);

      // sumar cantidad_asignada (fall back si no hay asignaciones)
      const cantidadAsignadaTotal = asignaciones.length
        ? asignaciones.reduce(
            (s, a) => s + (Number(a.cantidad_asignada) || 0),
            0
          )
        : getCantidadFallback(item);

      // acumular asignacion oids y seriales
      asignaciones.forEach((a) => {
        if (a.asignacion_oid != null)
          asignacionesSet.add(Number(a.asignacion_oid));
        if (Array.isArray(a.seriales)) {
          a.seriales.forEach((s) => {
            if (s || s === 0) serialesSet.add(String(s));
          });
        }
      });

      const serialesItem = asignaciones
        .flatMap((a) => a.seriales || [])
        .filter(Boolean);

      const valor_unitario = getValorUnitario(item);

      return {
        item: index + 1,
        po_producto_oid: getPoProductoOid(item),
        descripcion: getDescripcion(item),
        seriales: serialesItem.length > 0 ? serialesItem : [""],
        valor_unitario,
        unidad: getUnidad(item),
        cantidad: cantidadAsignadaTotal,
      };
    });

    const asignaciones_oids = Array.from(asignacionesSet);
    const seriales_globales = Array.from(serialesSet);

    const cantidad_total_items = balanceItems.reduce(
      (s, b) => s + (Number(b.cantidad) || 0),
      0
    );
    const valor_total = balanceItems.reduce(
      (s, b) => s + (Number(b.cantidad) || 0) * (Number(b.valor_unitario) || 0),
      0
    );

    // 4) Actualizar el jsonEntrega antes de enviar
    jsonEntrega.entrega.items = mergedItems;
    jsonEntrega.entrega.balance_items = balanceItems;
    jsonEntrega.entrega.cantidad_total_items = cantidad_total_items;
    jsonEntrega.entrega.valor_total = valor_total;
    jsonEntrega.entrega.seriales_globales = seriales_globales;
    jsonEntrega.asignaciones_oids = asignaciones_oids;

    // 5) Construcción del body final
    const body = {
      valor_total: jsonEntrega.entrega.valor_total,
      oidResponsable: usernameFromState?.username,
      jsonDetalleSalida: jsonEntrega,
      idProyecto: jsonEntrega.proyecto.proyecto_oid,
      asignaciones_oids: jsonEntrega.asignaciones_oids,
      id_salida: recordUpdate.oid,
    };

    try {
      // Paso 1: update salida en backend
      const response = await updateSalidaBodegaService(recordUpdate.oid, body);

      if (!response || response.status !== 200) {
        notification.error({
          message: "Error en la entrega",
          description: response?.message || "No se pudo actualizar la entrega.",
          placement: "topRight",
        });
        return;
      }

      notification.success({
        message: "Entrega actualizada",
        description: "La entrega se actualizo exitosamente.",
        placement: "topRight",
      });
    } catch (error) {
      notification.error({
        message: "Error en el servidor",
        description: error.message || "Error inesperado al actualizar entrega.",
        placement: "topRight",
      });
    } finally {
      // Paso 3: Limpieza y recarga SIEMPRE se ejecuta
      form.resetFields(); // limpiar después de confirmar
      setModalEntregaFecha(false);
      setModalEntrega(false);
      setProductosSeleccionados([]);
      setProductosUnificados([]);
      setModalVisible(false);
      setProyectoSeleccionado(null);
      setBusquedaProducto("");
      setListaParticipantes([]);
      setListaParticipantesSelecionados([]);
      fetchPlanes();
      cargarDatos();
      closeModal();
    }

    // Aquí iría el fetch/axios para enviar body al backend...
  };

  const columnsParticipantes = [
    {
      title: "Código SIRR",
      dataIndex: "codigo_sirr",
      key: "codigo_sirr",
    },
    {
      title: "Nombre",
      dataIndex: "nombre_completo",
      key: "nombre_completo",
    },
    {
      title: "Identificación",
      dataIndex: "identificacion",
      key: "identificacion",
      render: (val) => val ?? "N/A",
    },
  ];

  // 🔹 Función para normalizar productos con asignaciones
  const normalizarProductos = (productos, id_salida) => {
    const resultado = [];
    productos.forEach((producto) => {
      // Buscar si ya existe el producto en resultado
      let existente = resultado.find(
        (p) => p.po_item.po_producto_oid === producto.po_producto_oid
      );

      // Transformar asignaciones completas
      const asignaciones = producto.asignaciones.map((asig) => ({
        asignacion_oid: asig.asignacion_oid,
        cantidad_asignada: asig.cantidad_asignada,
        plan_oid: asig.plan_oid,
        producto_plan: asig.producto_plan,
      }));

      // IDs de asignaciones (solo para enviar al backend)
      const asignacionesIds = producto.asignaciones.map(
        (asig) => asig.asignacion_oid
      );

      if (existente) {
        // Concatenamos asignaciones completas
        existente.asignaciones.push(...asignaciones);

        // Concatenamos IDs de asignaciones
        existente.asignaciones_ids.push(...asignacionesIds);
      } else {
        // Creamos producto con estructura extendida
        resultado.push({
          po_item: {
            po_producto_oid: producto.po_producto_oid,
            descripcion_po: producto.descripcion_po,
            cantidad_po: producto.cantidad_po,
            cantidad_total: producto.cantidad_total,
            valor_unitario: producto.valor_unitario,
            unidad_po: producto.unidad_po,
          },
          asignaciones, // 🔹 Detalle completo
          asignaciones_ids: asignacionesIds, // 🔹 Solo los IDs
          id_salida, // 🔹 Lo agregamos también
          producto,
        });
      }
    });

    return resultado;
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1400px", margin: "0 auto" }}>
      <Row gutter={24}>
        <Col span={16}>
          <Card>
            <Title level={2} style={{ marginBottom: 24 }}>
              <ShoppingCartOutlined /> Gestión de entrega
            </Title>

            {/* Selector de Proyecto */}
            <Card size="small" style={{ marginBottom: "20px" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Text strong>Proyecto</Text>

                {isEditing ? (
                  // 👇 Si está en edición, solo mostramos texto
                  <Text>
                    {recordUpdate?.jsonDetalleSalida?.proyecto?.codigo_interno}{" "}
                    - {recordUpdate?.jsonDetalleSalida?.proyecto?.implementador}
                  </Text>
                ) : (
                  // 👇 Si NO está en edición, mostramos el Select normal
                  <Select
                    placeholder="Código Interno - Implementador"
                    style={{ width: "100%" }}
                    onChange={handleProyectoChange}
                    size="large"
                    loading={loading}
                    showSearch
                    filterOption={(input, option) =>
                      option?.children
                        ?.toString()
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {proyectosUnicos.map((item) => (
                      <Option
                        key={item.key}
                        value={item.value}
                        proyecto={item.proyecto}
                      >
                        {item.value}
                      </Option>
                    ))}
                  </Select>
                )}
              </Space>
            </Card>

            {/* Buscador y Lista de Productos */}
            {proyectoSeleccionado && (
              <Card>
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Row justify="space-between" align="middle">
                    <Col>
                      <Title level={4} style={{ margin: 0 }}>
                        Productos Disponibles ({productosFiltrados.length})
                      </Title>
                    </Col>
                    <Col>
                      <Search
                        placeholder="Buscar por nombre, orden o proveedor..."
                        allowClear
                        style={{ width: 300 }}
                        value={busquedaProducto}
                        onChange={(e) => setBusquedaProducto(e.target.value)}
                        prefix={<SearchOutlined />}
                      />
                    </Col>
                  </Row>

                  <Divider style={{ margin: "12px 0" }} />

                  {productosFiltrados.length === 0 ? (
                    <Empty
                      description={
                        busquedaProducto
                          ? "No se encontraron productos con esa búsqueda"
                          : "No hay productos disponibles"
                      }
                    />
                  ) : (
                    <List
                      dataSource={productosFiltrados}
                      pagination={{
                        pageSize: 5,
                        showSizeChanger: false,
                        showQuickJumper: true,
                      }}
                      renderItem={(item) => {
                        const isSelected = productosSeleccionados.some(
                          (p) =>
                            p.po_item.descripcion_po ===
                            item.po_item.descripcion_po
                        );

                        return (
                          <List.Item
                            style={{
                              cursor: "pointer",
                              backgroundColor: isSelected ? "#e6f7ff" : "white",
                              border: isSelected
                                ? "2px solid #1890ff"
                                : "1px solid #d9d9d9",
                              borderRadius: "8px",
                              marginBottom: "8px",
                              padding: "16px",
                              transition: "all 0.3s ease",
                              position: "relative", // importante para que el botón se posicione respecto a este item
                            }}
                            onClick={() => handleProductoSelect(item)}
                          >
                            <div
                              style={{ width: "100%", paddingBottom: "50px" }}
                            >
                              {/* Fila superior: Descripción y datos numéricos */}
                              <Row
                                gutter={16}
                                align="middle"
                                style={{ marginBottom: "12px" }}
                              >
                                <Col flex="auto">
                                  <Text strong style={{ fontSize: "16px" }}>
                                    {item.po_item.descripcion_po}
                                  </Text>
                                </Col>
                                <Col>
                                  <Space size="large">
                                    <div>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Cantidad
                                      </Text>
                                      <Text strong>
                                        {item.cantidad_total} unidades
                                      </Text>
                                    </div>
                                    <div>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Valor Unitario
                                      </Text>
                                      <Text strong>
                                        {formatCurrency(
                                          item.valor_total / item.cantidad_total
                                        )}
                                      </Text>
                                    </div>
                                    <div>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "12px",
                                          display: "block",
                                        }}
                                      >
                                        Valor Total
                                      </Text>
                                      <Text strong style={{ color: "#1890ff" }}>
                                        {formatCurrency(item.valor_total)}
                                      </Text>
                                    </div>
                                  </Space>
                                </Col>
                              </Row>

                              {/* Fila inferior: Proveedor y Órdenes */}
                              <Row gutter={16} align="middle">
                                <Col flex="auto">
                                  <Space size="middle">
                                    <div>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "12px",
                                          marginRight: "8px",
                                        }}
                                      >
                                        Proveedor:
                                      </Text>
                                      {[
                                        ...new Set(
                                          item.po_items_relacionados.map(
                                            (rel) => rel.po_item.po.proveedor
                                          )
                                        ),
                                      ].map((proveedor, idx) => (
                                        <Tag
                                          key={idx}
                                          color="green"
                                          style={{ margin: "2px" }}
                                        >
                                          {proveedor}
                                        </Tag>
                                      ))}
                                    </div>
                                    <div>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: "12px",
                                          marginRight: "8px",
                                        }}
                                      >
                                        Órdenes:
                                      </Text>
                                      <Text>
                                        {item.po_items_relacionados
                                          .map(
                                            (rel) => rel.po_item.po.numero_orden
                                          )
                                          .join(", ")}
                                      </Text>
                                    </div>
                                  </Space>
                                </Col>
                              </Row>

                              {/* Botón fijo en esquina inferior derecha */}
                              <Button
                                type={isSelected ? "primary" : "default"}
                                icon={
                                  isSelected ? (
                                    <CheckCircleOutlined />
                                  ) : (
                                    <PlusOutlined />
                                  )
                                }
                                size="middle"
                                style={{
                                  position: "absolute",
                                  bottom: "16px",
                                  right: "16px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation(); // para que no active el onClick del List.Item
                                  handleProductoSelect(item);
                                }}
                              >
                                {isSelected ? "Seleccionado" : "Seleccionar"}
                              </Button>
                            </div>
                          </List.Item>
                        );
                      }}
                    />
                  )}
                </Space>
              </Card>
            )}
          </Card>
        </Col>

        {/* Panel lateral de productos seleccionados */}
        <Col span={8}>
          <Card
            style={{
              position: "sticky",
              top: "20px",
              backgroundColor:
                productosSeleccionados.length > 0 ? "#f6ffed" : "#fafafa",
            }}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              {/* Header del carrito */}
              <Row justify="space-between" align="middle">
                <Title level={4} style={{ margin: 0, color: "#52c41a" }}>
                  <Badge count={productosSeleccionados.length} showZero>
                    <ShoppingCartOutlined style={{ marginRight: 8 }} />
                    Carrito
                  </Badge>
                </Title>

                {productosSeleccionados.length > 0 && (
                  <Button
                    size="small"
                    type="link"
                    onClick={() => setProductosSeleccionados([])}
                  >
                    Limpiar todo
                  </Button>
                )}
              </Row>

              {/* Botón de asistentes - Posición mejorada */}
              {proyectoSeleccionado != null && (
                <Alert
                  message={
                    <Space
                      align="center"
                      style={{ width: "100%", justifyContent: "space-between" }}
                    >
                      <Text strong>Productos seleccionados</Text>
                      <Button
                        type="primary"
                        size="small"
                        icon={<UserAddOutlined />}
                        onClick={() => setModalParticipantes(true)}
                        style={{
                          backgroundColor: "#1890ff",
                          borderColor: "#1890ff",
                          borderRadius: "6px",
                        }}
                      >
                        Gestionar Asistentes
                      </Button>
                    </Space>
                  }
                  type="info"
                  showIcon={false}
                  style={{
                    backgroundColor: "#e6f7ff",
                    border: "1px solid #91d5ff",
                    borderRadius: "8px",
                  }}
                />
              )}

              <>
                {productosSeleccionadosEntregados.length > 0 && (
                  <List
                    size="small"
                    dataSource={productosSeleccionadosEntregados}
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                    renderItem={(item) => (
                      <List.Item
                        style={{
                          backgroundColor: "white",
                          borderRadius: "6px",
                          marginBottom: "8px",
                          padding: "8px 12px",
                          border: "1px solid #d9d9d9",
                        }}
                        actions={[
                          <Popconfirm
                            title="¿Eliminar producto?"
                            description="¿Estás seguro de eliminar este producto de la entrega?"
                            okText="Sí"
                            cancelText="No"
                            onConfirm={() =>
                              removeProductoSeleccionadoEntregado(item)
                            }
                          >
                            <Button
                              type="text"
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                            />
                          </Popconfirm>,
                        ]}
                      >
                        <List.Item.Meta
                          title={
                            <Text strong style={{ fontSize: "14px" }}>
                              {item.po_item.descripcion_po}
                            </Text>
                          }
                          description={
                            <Space direction="vertical" size="small">
                              <Text type="secondary">
                                Cant: {item.po_item.cantidad_total} | Valor Uni:
                                {formatCurrency(item.po_item.valor_unitario)}
                              </Text>
                              <Text strong style={{ color: "#1890ff" }}>
                                {formatCurrency(
                                  item.po_item.cantidad_total *
                                    item.po_item.valor_unitario
                                )}
                              </Text>
                            </Space>
                          }
                        />
                      </List.Item>
                    )}
                  />
                )}
              </>

              {productosUnificados.length === 0 ? (
                <Empty
                  description="No hay productos seleccionados"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ) : (
                <>
                  {productosSeleccionados.length > 0 && (
                    <List
                      size="small"
                      dataSource={productosSeleccionados}
                      style={{ maxHeight: "400px", overflowY: "auto" }}
                      renderItem={(item) => (
                        <List.Item
                          style={{
                            backgroundColor: "white",
                            borderRadius: "6px",
                            marginBottom: "8px",
                            padding: "8px 12px",
                            border: "1px solid #d9d9d9",
                          }}
                          actions={[
                            <Button
                              type="text"
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() =>
                                removeProductoSeleccionado(
                                  item.po_item.descripcion_po
                                )
                              }
                            />,
                          ]}
                        >
                          <List.Item.Meta
                            title={
                              <Text strong style={{ fontSize: "14px" }}>
                                {item.po_item.descripcion_po}
                              </Text>
                            }
                            description={
                              <Space direction="vertical" size="small">
                                <Text type="secondary">
                                  Cant: {item.cantidad_total} | Valor Uni:{" "}
                                  {formatCurrency(item.po_item.valor_unitario)}
                                </Text>
                                <Text strong style={{ color: "#1890ff" }}>
                                  {formatCurrency(
                                    item.cantidad_total *
                                      item.po_item.valor_unitario
                                  )}
                                </Text>
                              </Space>
                            }
                          />
                        </List.Item>
                      )}
                    />
                  )}

                  <Divider style={{ margin: "12px 0" }} />

                  <Row gutter={16}>
                    <Col span={24}>
                      <Statistic
                        title="Total General"
                        value={totalSeleccionados}
                        formatter={(value) => formatCurrency(value)}
                        valueStyle={{ color: "#3f8600", fontWeight: "bold" }}
                      />
                    </Col>
                  </Row>

                  {/* Sección de acciones principales */}
                  <Space
                    style={{ width: "100%" }}
                    direction="vertical"
                    size="middle"
                  >
                    <Button
                      type="primary"
                      size="large"
                      icon={<EyeOutlined />}
                      onClick={() => setModalVisible(true)}
                      block
                      style={{
                        borderRadius: "8px",
                        height: "48px",
                        fontSize: "16px",
                      }}
                    >
                      Ver Resumen
                    </Button>

                    <Button
                      type="primary"
                      size="large"
                      icon={<SendOutlined />}
                      block
                      disabled={
                        isEditing
                          ? !(productosSeleccionados?.length > 0 || hayCambios)
                          : !(productosSeleccionados?.length > 0)
                      }
                      style={{
                        backgroundColor: isEditing
                          ? !(productosSeleccionados?.length > 0 || hayCambios)
                            ? "#b1aeaeff"
                            : "#52c41a"
                          : !(productosSeleccionados?.length > 0)
                          ? "#b1aeaeff"
                          : "#52c41a",
                        borderColor: isEditing
                          ? !(productosSeleccionados?.length > 0 || hayCambios)
                            ? "#b1aeaeff"
                            : "#52c41a"
                          : !(productosSeleccionados?.length > 0)
                          ? "#b1aeaeff"
                          : "#52c41a",
                        borderRadius: "8px",
                        height: "48px",
                        fontSize: "16px",
                        boxShadow: isEditing
                          ? !(productosSeleccionados?.length > 0 || hayCambios)
                            ? "none"
                            : "0 2px 8px rgba(82, 196, 26, 0.3)"
                          : !(productosSeleccionados?.length > 0)
                          ? "none"
                          : "0 2px 8px rgba(82, 196, 26, 0.3)",
                        cursor: isEditing
                          ? !(productosSeleccionados?.length > 0 || hayCambios)
                            ? "not-allowed"
                            : "pointer"
                          : !(productosSeleccionados?.length > 0)
                          ? "not-allowed"
                          : "pointer",
                      }}
                      onClick={() => {
                        if (
                          (isEditing &&
                            !(
                              listaParticipantesSeleccionados?.length > 0 ||
                              hayCambios
                            )) ||
                          (!isEditing &&
                            !(listaParticipantesSeleccionados?.length > 0))
                        ) {
                          message.warning(
                            isEditing
                              ? "Debe agregar participantes o realizar cambios antes de actualizar la entrega."
                              : "Debe seleccionar al menos un participante antes de generar la entrega."
                          );
                          return;
                        }
                        setModalEntrega(true);
                      }}
                    >
                      {isEditing ? "Actualizar Entrega" : "Generar Entrega"}
                    </Button>
                  </Space>
                </>
              )}
            </Space>
          </Card>
        </Col>
      </Row>

      {/* Modal de Resumen */}
      <Modal
        title="Resumen de Productos Seleccionados"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setModalVisible(false)}>
            Cerrar
          </Button>,
        ]}
        width="80vw"
      >
        <Table
          dataSource={productosUnificados}
          columns={columnasEntrega}
          pagination={false}
          rowKey={(record) => record.po_item.po_producto_oid}
          scroll={{ y: 600 }}
          summary={() => (
            <Table.Summary.Row style={{ backgroundColor: "#f0f9ff" }}>
              <Table.Summary.Cell index={0} colSpan={2}>
                <Text strong style={{ fontSize: "16px" }}>
                  RESUMEN TOTAL
                </Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="center">
                <Tag color="blue" style={{ fontSize: "14px" }}>
                  {productosSeleccionados.reduce(
                    (total, item) => total + item.cantidad_total,
                    0
                  )}{" "}
                  unidades
                </Tag>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">
                <Text strong style={{ fontSize: "18px", color: "#1890ff" }}>
                  {formatCurrency(totalSeleccionados)}
                </Text>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />
      </Modal>

      {/* Modal de Generar Entrega */}
      <Modal
        title={
          <Space>
            <SendOutlined style={{ color: "#52c41a" }} />
            <Text strong>Confirmar Entrega de Productos</Text>
          </Space>
        }
        open={modalEntrega}
        onCancel={() => setModalEntrega(false)}
        footer={[
          <Button key="cancel" onClick={() => setModalEntrega(false)}>
            Cancelar
          </Button>,
          <Button
            key="confirm"
            type="primary"
            style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
            onClick={() => setModalEntregaFecha(true)}
          >
            Confirmar Entrega
          </Button>,
        ]}
        width="80vw"
      >
        <Row gutter={16} style={{ marginBottom: 16 }}>
          <Col span={6}>
            <Card>
              <Statistic
                title="Productos Únicos"
                value={productosUnificados.length}
                prefix={<ShoppingCartOutlined />}
                valueStyle={{ color: "#3f8600" }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Cantidad Total"
                value={productosUnificados.reduce(
                  (total, item) => total + item.cantidad_total,
                  0
                )}
                suffix="unidades"
                valueStyle={{ color: "#1890ff" }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Órdenes de Compra"
                value={
                  [
                    ...new Set(
                      productosUnificados.map(
                        (item) => item.po_item?.numero_orden
                      )
                    ),
                  ].length
                }
                valueStyle={{ color: "#722ed1" }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <Statistic
                title="Valor Total"
                value={totalSeleccionados}
                formatter={(value) => formatCurrency(value)}
                valueStyle={{ color: "#cf1322", fontWeight: "bold" }}
              />
            </Card>
          </Col>
        </Row>

        <Alert
          message="Confirmación de Entrega"
          description={`Se procesará la entrega de ${
            productosUnificados.length
          } productos únicos con una cantidad total de ${productosUnificados.reduce(
            (total, item) => total + item.cantidad_total,
            0
          )} unidades por un valor total de ${formatCurrency(
            totalSeleccionados
          )}`}
          type="success"
          showIcon
          style={{ marginBottom: 16 }}
        />

        {proyectoSeleccionado && (
          <Card
            size="small"
            style={{ marginBottom: 16, backgroundColor: "#fafafa" }}
          >
            <Text strong>Proyecto: </Text>
            <Text>
              {proyectoSeleccionado.codigo_interno} -{" "}
              {proyectoSeleccionado.implementador}
            </Text>
            <br />
            <Text strong>Profesional: </Text>
            <Text>{proyectoSeleccionado.nombre_profesional_gse}</Text>
          </Card>
        )}

        <Table
          dataSource={productosUnificados}
          columns={columnasEntrega}
          pagination={false}
          rowKey={(record) => record.po_item.descripcion_po}
          size="small"
          scroll={{ y: 300 }}
          summary={() => (
            <Table.Summary.Row style={{ backgroundColor: "#f0f9ff" }}>
              <Table.Summary.Cell index={0} colSpan={2}>
                <Text strong style={{ fontSize: "16px", color: "#52c41a" }}>
                  TOTAL A ENTREGAR
                </Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} align="center">
                <Text strong style={{ fontSize: "18px", color: "#52c41a" }}>
                  {productosSeleccionados.reduce(
                    (total, item) => total + item.cantidad_total,
                    0
                  )}{" "}
                  unidades
                </Text>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">
                <Text strong style={{ fontSize: "18px", color: "#52c41a" }}>
                  {formatCurrency(totalSeleccionados)}
                </Text>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />
      </Modal>

      {/* Modal para la fecha de la entrega */}

      <Modal
        title="Seleccionar fecha de entrega"
        open={modalEntregaFecha}
        onCancel={() => setModalEntregaFecha(false)}
        onOk={() => form.submit()} // ✅ dispara el submit del form
        okText="Confirmar"
        cancelText="Cancelar"
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleConfirmarEntrega} // ✅ se ejecuta solo si pasa la validación
        >
          <Form.Item
            name="fechaEntrega"
            label="Fecha de entrega"
            rules={[
              { required: true, message: "Seleccione la fecha de entrega" },
            ]}
          >
            <DatePicker
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              placeholder="Seleccione día, mes y año"
            />
          </Form.Item>

          <Form.Item
            name="valorTotalEntrega"
            label="Valor total de la entrega"
            rules={[
              {
                required: false, // No obligatorio
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder="Ingrese el valor total (opcional)"
              formatter={(value) =>
                `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              } // Formato: $ 1,000,000
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")} // Elimina símbolos al guardar
              min={0}
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal reutilizable */}
      <ModalParticipantes
        visible={modalParticipantes}
        onClose={() => setModalParticipantes(false)}
        participantes={listaParticipantes}
        participantesSeleccionados={listaParticipantesSeleccionados} // ← NUEVA PROP
        onSave={setListaParticipantesSelecionados}
        width="80vw"
      />
    </div>
  );
};

export default SalidaBodega_v2;
